<template>
	<Transition enter-active-class="animated fadeInDown faster" leave-active-class="animated fadeOutUp faster">
		<JFlex class="s-w-full s-h-9 s-justify-center s-pointer-events-none " v-if="isVisible">
			<JFlex
				class="s-items-center s-justify-between s-p-1 s-px-2 s-bg-gray-100 s-border s-border-gray-200 s-text-gray-600 s-text-sm s-font-bold s-rounded-lg"
			>
				<JFlex class="s-items-center">
					<CIcon name="information-circle" class="s-mr-2 s-w-6 s-h-6 s-fill-current s-text-gray-900" />
					<JText class="s-truncate s-text-gray-900">{{ $t("templates.changePromptText") }}</JText>
				</JFlex>
			</JFlex>
		</JFlex>
	</Transition>
</template>

<script>
export default {
	props: {
		isVisible: {
			type: Boolean,
			default: () => false
		}
	}
}
</script>
